import { render, staticRenderFns } from "./ViewSections.vue?vue&type=template&id=09c74bc0"
import script from "./ViewSections.vue?vue&type=script&lang=js"
export * from "./ViewSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports